import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/Api';
import { api_url_v1 } from '../utils/Config';

const initialState = {
  items: [],
  selectedPost: null,
  meta: {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0
  },
  loading: false,
  error: null
};

export const fetchReportedPosts = createAsyncThunk(
  'reportedPosts/fetchReportedPosts',
  async ({ page, limit,filter,filter_type }, { getState }) => {
    const { auth: { token } } = getState();
    const params = {
      page,
      limit,
      [`filter[${filter_type}]`]: `${filter}`,

    }
    const response = await api.get(`${api_url_v1}/reported-posts`, {
      params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    
    return {
      data: response.data.data || [],
      meta: response.data.meta || {
        current_page: page,
        last_page: 1,
        per_page: limit,
        total: 0
      }
    };
  }
);

export const fetchPostDetails = createAsyncThunk(
  'reportedPosts/fetchPostDetails',
  async (postId, { getState }) => {
    const { auth: { token } } = getState();
    const response = await api.get(`${api_url_v1}/reported-posts/${postId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  }
);


export const updatePostStatus = createAsyncThunk(
  'reportedPosts/updatePostStatus',
  async ({ postId, status }, { getState }) => {
    const { auth: { token } } = getState();
    const response = await api.put(`${api_url_v1}/reported-posts/${postId}`, { status }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    // Return just what we need
    return { postId, status }; // Don't return response.data directly
  }
);

const reportedPostsSlice = createSlice({
  name: 'reportedPosts',
  initialState,
  reducers: {
    setSelectedPost: (state, action) => {
      state.selectedPost = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportedPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReportedPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchReportedPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchPostDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPostDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPost = action.payload.data;
      })
      .addCase(fetchPostDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updatePostStatus.pending, (state, action) => {
        
       })
       .addCase(updatePostStatus.fulfilled, (state, action) => {
        const { postId, status } = action.payload;
        const post = state.items.find(post => post.id === postId);
        if (post) {
          post.status = status;
        }
        if (state.selectedPost?.id === postId) {
          state.selectedPost.status = status;
        }

          state.loading = false;
      });

    
     
  }
});

export const { setSelectedPost } = reportedPostsSlice.actions;
export default reportedPostsSlice.reducer;
